/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
import React from 'react';
import Image from 'next/image';
import Tooltip from '@common/Tooltip';
import AmenityToImageNameMap from '@constants/amenityImageMap';
import { getStaticIconsUrl } from '@utils/cloudflare';
import Amenity from '@customTypes/amenity';
import { slugify } from '@helpers/string';

type Props = {
  amenities: Amenity[];
  newHotelCardDesign?: boolean;
};

export default function Amenities({ amenities, newHotelCardDesign = false }: Props) {
  const getIcon = (item: Amenity): string => {
    const amenityImage = AmenityToImageNameMap[item.name];
    return getStaticIconsUrl(amenityImage);
  };
  return (
    <ul className="h-10 w-full flex flex-row justify-start items-center">
      {amenities.map((amenity) =>
        AmenityToImageNameMap &&
        AmenityToImageNameMap[amenity.name] &&
        amenity.name !== 'restrooms' ? (
          <Tooltip
            key={amenity.name}
            text={`${amenity.description} (${amenity.name})`}
            delay={1000}
          >
            <li
              className={`self-center h-10 ${
                newHotelCardDesign ? 'mr-3' : 'mr-4'
              } w-4 cursor-pointer`}
            >
              <Image
                data-testid={slugify(`amenity-${amenity.description}`)}
                src={getIcon(amenity)}
                height="40"
                width="16"
                alt={amenity.description}
                className="outline-none"
                style={
                  newHotelCardDesign
                    ? {
                      filter: 'invert(44%) sepia(6%) saturate(318%) hue-rotate(186deg)',
                    }
                    : {}
                }
              />
            </li>
          </Tooltip>
          ) : null,
      )}
    </ul>
  );
}
